import { videoRootUrl } from "./apiRoutes";

type TMediaObject = {
    id: string,
    mimetype?: string
};



const fileExt: Record<string, string> = {
    "video/mp4": "mp4",
    "video/webm": "webm"
};

export const getVideoUrl = (mediaObject: TMediaObject, mimetype?: string): string => {

    const fileId = mediaObject.id
    const mime = mimetype || mediaObject.mimetype;
    if (!mime) {
        throw new Error("unknown mimetype");
    }
    const ext = fileExt[mime] || "mp4"
    const url = `${videoRootUrl}/${fileId}.${ext}`;
    return url;
};